import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {getRequestUserShift,emptyRequestUserShift} from './Module';
import {Form, Select as SelectInput} from 'antd';
import jMoment from 'components/classes/Jmomen';
import uuidv1 from 'uuid/v1';
import MaterialIcon from 'components/common/MaterialIcon';

@connect((state) => ({
  userShift: state.FormBuilder.Common.SelectUserShift.userShift,
}), {
  getRequestUserShift,
  emptyRequestUserShift,
})
@autobind
/**
 *
 */
export default class SelectUserShiftInfo extends React.PureComponent {
  static propTypes = {
    inline: PropTypes.bool,
    label: PropTypes.string,
    userShiftId: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object,
      PropTypes.number,
    ]),
    userShift: PropTypes.object,
    getRequestUserShift: PropTypes.func,
    getRequestUserPersonnelShifts: PropTypes.func,
    emptyRequestUserShift: PropTypes.func,
  };

  static defaultProps = {
    inline: true,
    label: undefined,
  };

  /**
   *
   * @param {object} props
   */
  constructor(props) {
    super(props);
    this.state = {
      userShift: {},
      render: true,
    };
  }


  /**
   *
   */
  componentDidMount() {
    const {getRequestUserShift} = this.props;

    getRequestUserShift(this.props.userShiftId && this.props.userShiftId.workingHour , {}, (r) => {
      this.setState({userShift: r});
    });
  }

  /**
   *
   * @param {Object} np
   */
  componentWillReceiveProps(np) {
    if (!app._.isEqual(np.userShiftId, this.props.userShiftId)) {
      np.getRequestUserShift(np.userShiftId && np.userShiftId.workingHour, {}, (r) => {
        this.setState({userShift: r});
      });
    }
  }

  /**
   *
   */
  componentWillUnmount() {
    super.componentWillUnmount();
    this.props.emptyRequestUserShift();
  }


  /**
   *
   * @return {Object}
   * @private
   */
  _inline() {
    const {inline} = this.props;

    if (inline) {
      return {
        labelCol: {span: 6},
        wrapperCol: {span: 18},
      };
    }

    return {};
  }

  /**
   *
   * @return {XML}
   */
  render() {
    const {userShift, label} = this.state;

    return (
      <span>
        {userShift && userShift.data && userShift.data.workingHour && userShift.data.workingHour.name}
        </span>
    );
  }
}
